(function () {
  function markSizeChosen(root) {
    root.classList.add('ei-size-chosen');
    var button = root.querySelector('[data-ei-size-required]');
    if (!button) return;
    button.removeAttribute('disabled');
    var label = button.querySelector('span');
    if (label) label.textContent = button.dataset.eiNormalLabel;
  }

  // The variant-selects re-render round trip only reflects the newly chosen
  // size once the server resolves a matching variant; update the "Select"
  // text immediately on click instead of waiting on that network round trip.
  function updateSelectedSizeText(radio) {
    var fieldset = radio.closest('[data-ei-size-fieldset]');
    if (!fieldset) return;
    var span = fieldset.querySelector('[data-selected-value]');
    var label = fieldset.querySelector('label[for="' + radio.id + '"]');
    if (span && label) span.textContent = label.textContent;
  }

  // Native <details> can't reliably transition its content on close — removing
  // `open` hides the content immediately, before any CSS transition can play.
  // Drive the `.is-open` class ourselves so the collapse animates, and only
  // remove `open` once that transition actually finishes.
  function setupFaqAccordions(root) {
    root.querySelectorAll('.ei-product__faq-item details').forEach(function (details) {
      var summary = details.querySelector('summary');
      var content = details.querySelector('.ei-product__faq-content');
      if (!summary || !content || summary.dataset.eiFaqInit === 'true') return;
      summary.dataset.eiFaqInit = 'true';

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (details.open) {
          content.classList.remove('is-open');
          content.addEventListener(
            'transitionend',
            function onEnd(event) {
              if (event.target !== content) return;
              content.removeEventListener('transitionend', onEnd);
              details.open = false;
            }
          );
        } else {
          details.open = true;
          requestAnimationFrame(function () {
            content.classList.add('is-open');
          });
        }
      });
    });
  }

  // The size chart (from the size_chart metaobject) is authored in inches,
  // using either plain decimals ("4.75") or a whole number plus a unicode
  // fraction glyph ("19 ¼"), optionally with a trailing inch mark. Toggling
  // to centimeters converts those values on the fly instead of requiring a
  // second hand-maintained table.
  var EI_SIZE_GUIDE_FRACTIONS = {
    '¼': 0.25, '½': 0.5, '¾': 0.75,
    '⅓': 1 / 3, '⅔': 2 / 3,
    '⅛': 0.125, '⅜': 0.375, '⅝': 0.625, '⅞': 0.875,
    '⅕': 0.2, '⅖': 0.4, '⅗': 0.6, '⅘': 0.8,
    '⅙': 1 / 6, '⅚': 5 / 6
  };
  // Matches the ENTIRE cell text (after stripping inch marks) as either a
  // number, a fraction glyph, or both — anything else (like "32 Short", a
  // size label that happens to start with a number) is rejected so label
  // cells are never mistaken for measurements.
  var EI_SIZE_GUIDE_VALUE_RE = /^(\d+(?:\.\d+)?)?\s*([¼½¾⅓⅔⅛⅜⅝⅞⅕⅖⅗⅘⅙⅚])?$/;

  function parseSizeGuideInches(rawText) {
    var text = rawText.trim().replace(/["”″]/g, '').trim();
    var match = text.match(EI_SIZE_GUIDE_VALUE_RE);
    if (!match || (!match[1] && !match[2])) return null;
    var whole = match[1] ? parseFloat(match[1]) : 0;
    var fraction = match[2] ? EI_SIZE_GUIDE_FRACTIONS[match[2]] : 0;
    return whole + fraction;
  }

  function setupSizeGuideUnitToggle(root) {
    root.querySelectorAll('.ei-product__size-guide-body').forEach(function (body) {
      var table = body.querySelector('.size-table');
      var radios = body.querySelectorAll('.size-unit-toggle input[type="radio"]');
      if (!table || !radios.length || table.dataset.eiUnitInit === 'true') return;
      table.dataset.eiUnitInit = 'true';

      var cells = [];
      table.querySelectorAll('tbody td').forEach(function (cell) {
        var inches = parseSizeGuideInches(cell.textContent);
        if (inches === null) return;
        cell.dataset.eiOriginalText = cell.textContent.trim();
        cell.dataset.eiInches = inches;
        cells.push(cell);
      });

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          cells.forEach(function (cell) {
            if (radio.value === 'cm') {
              cell.textContent = Math.round(parseFloat(cell.dataset.eiInches) * 2.54 * 10) / 10;
            } else {
              cell.textContent = cell.dataset.eiOriginalText;
            }
          });
        });
      });
    });
  }

  // The size guide panel's own controls (the Inches/cm unit toggle) live
  // inside <variant-selects>, so their 'change' events bubble into Dawn's
  // VariantSelects listener, which assumes any radio it sees belongs to a
  // product option and dereferences a `.product-form__input` ancestor that
  // doesn't exist here. Stop those events from leaving the panel.
  function setupSizeGuidePanelIsolation(root) {
    root.querySelectorAll('.ei-product__size-guide-panel').forEach(function (panel) {
      if (panel.dataset.eiChangeIsolated === 'true') return;
      panel.dataset.eiChangeIsolated = 'true';
      panel.addEventListener('change', function (event) {
        event.stopPropagation();
      });
    });
  }

  function setup(root) {
    if (!root || root.dataset.eiSizeGateInit === 'true') return;
    root.dataset.eiSizeGateInit = 'true';

    setupFaqAccordions(root);
    setupSizeGuideUnitToggle(root);
    setupSizeGuidePanelIsolation(root);

    root.addEventListener('change', function (event) {
      // Scoped to the size-options radios specifically, not the whole
      // fieldset — the size guide's own unit-toggle radios (Inches/cm) live
      // inside this fieldset's sibling size-guide panel too, and would
      // otherwise match here.
      if (event.target.closest('.ei-product__size-options')) {
        markSizeChosen(root);
        updateSelectedSizeText(event.target);
      }
    });

    // Each variant change re-renders <variant-selects> from the server, which always
    // starts the size fieldset unchecked-looking again — reassert the chosen state
    // once the user has genuinely picked a size.
    if (Array.isArray(root.postProcessHtmlCallbacks)) {
      root.postProcessHtmlCallbacks.push(function () {
        if (root.classList.contains('ei-size-chosen')) markSizeChosen(root);
      });
    }
  }

  document.querySelectorAll('product-info.ei-main-product').forEach(setup);
})();
